import { EyeOutlined } from '@ant-design/icons';
import { Modal } from '@components/common/Modal/Modal';
import { PageTitle } from '@components/common/PageTitle/PageTitle';
import { PagingType, UTable } from '@components/common/UTable/UTable';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { useGetOrganizationsTreeQuery } from '@/api/organizations/api';
import {
  useCreateRoleMutation,
  useGetPermissionsQuery,
  useGetRolesQuery,
} from '@/api/roles/api';
import { PermissionResponse, RoleResponse } from '@/api/roles/types';
// import './style.scss';
import { createModalConfig } from '@/pages/Administration/components/roles/modal.config';
import { PageableResponse } from '@/shared/api/types';
import { administration } from '@/shared/security/permissions/administration';
import { groupByModule, mapTableIndexWithPage } from '@/utils/utils';

import { columns } from './columns.config';
import { message } from 'antd';

export const RolesTable = () => {
  const [pageable, setPageable] = useState<PagingType>({ page: 0, size: 10 });
  const [filters, setFilters] = useState({});
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [createRole, { isSuccess: isRoleCreateSuccess, isLoading: isRoleSaving }] =
    useCreateRoleMutation();

  const navigate = useNavigate();

  const { data, isLoading } = useGetRolesQuery({ pageable: pageable, filters });
  const {
    data: allOrganizations,
    isLoading: isOrganizationsLoading,
    isFetching: isOrganizationsFetching,
  } = useGetOrganizationsTreeQuery();

  const { data: allPermissions, isLoading: isPermissionsLoading } =
    useGetPermissionsQuery({});

  const onRoleCreate = async (payload: any) => {
    await createRole(payload).unwrap();
    setIsCreateModalOpen(false);
    message.success('Роль успешно сохранена');
  };

  return (
    <>
      <PageTitle title={'Роли'} />
      <Modal
        mode={'form'}
        schema={createModalConfig(groupByModule(allPermissions as PermissionResponse[]))}
        title={'Добавить роль'}
        open={isCreateModalOpen}
        onSubmit={(payload: any) => {
          onRoleCreate(payload);
        }}
        onCancel={() => {
          setIsCreateModalOpen(false);
        }}
        layout={{ formLayout: 'vertical', itemLayout: 'vertical' }}
        formKey={'createForm'}
        confirmLoading={isOrganizationsLoading || isRoleSaving}
      />
      <UTable
        size={'small'}
        data={mapTableIndexWithPage(
          (data as PageableResponse<RoleResponse>)?.content as any[],
          pageable,
        )}
        columns={columns}
        loading={isLoading || isPermissionsLoading}
        paging={pageable}
        onPagingChange={setPageable}
        buttons={[
          {
            addBtn: true,
            action: () => setIsCreateModalOpen(true),
            security: {
              permissions: administration.roles.add,
            },
          },
        ]}
        actions={() => [
          {
            icon: <EyeOutlined />,
            action: (record) => {
              navigate(`/administration/roles/${record?.name}`);
            },
            security: {
              permissions: administration.roles.view,
            },
          },
        ]}
      />
    </>
  );
};
